export const LOAD_CARD_STATUS = 'LOAD_CARD_STATUS'
export const LOAD_CARDS = 'LOAD_CARDS'
export const LOAD_ASSIGNED_CARD = 'LOAD_ASSIGNED_CARD'